import { lazy } from "react";
import { ProtectedRoute } from "../components/ProtectedRoute";
import PasswordContextProvider from "../contexts/PasswordContext";

const documentsRouteConfig = [
  {
    parent: {
      exact: true,
      path: "/document/tagging",
      element: ProtectedRoute,
      permission_id: 20,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/tagging/DocumentTagging")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/monitor/tagging",
      element: ProtectedRoute,
      permission_id: 53,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/tagging/monitoring/DocumentTaggingMonitoring.jsx")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/transmitting",
      element: ProtectedRoute,
      permission_id: 25,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/transferring/DocumentTransferring")),
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/transmitting-gas-document",
      element: ProtectedRoute,
      permission_id: 27,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/gas-transmitting/DocumentTransmittingGAS")),
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/monitor/official-receipt",
      element: ProtectedRoute,
      permission_id: 35,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/transferring/monitoring/DocumentTransferringMonitoring")
      ),
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/transmitting-file-voucher",
      element: ProtectedRoute,
      permission_id: 33,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/filed-voucher-transmitting/DocumentTransmittingFiledVoucher")
      ),
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/filing",
      element: ProtectedRoute,
      permission_id: 26,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/distributing/DocumentDistributing")),
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/returned-documents",
      element: ProtectedRoute,
      permission_id: 20,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/tagging/returned/ReturnedDocument")),
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/returned-documents",
      element: ProtectedRoute,
      permission_id: 20,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/tagging/returned/ReturnedDocument")),
    },
  },
  {
    parent: {
      exact: true,
      path: "/document/voucher-transmitting",
      element: ProtectedRoute,
      permission_id: 19,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/transmitting/DocumentTransmitting")),
    },
  },
];

export default documentsRouteConfig;
